import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import {
  DefaultLayout,
  NotFoundComponent,
  VerifyEmailComponent,
} from "components";
import { SetReload } from "store/actions";

const AuthSwitchWrapper = (props) => {
  const {
    path,
    exact = false,
    truthyComponent: TruthyComponent,
    falsyComponent: FalsyComponent,
    loggedIn,
    dbUser,
    user,
    reload,
    bindReload,
    ...rest
  } = props;

  const localReload = reload;

  useEffect(() => {
    bindReload(false);
  }, [reload, bindReload]);

  const tokenExpirationTime = +window.sessionStorage.getItem(
    "tokenExpirationTime"
  );
  const currentTime = Date.now();

  // if (!navigator.onLine || !loggedIn) {
  if (!loggedIn || tokenExpirationTime < currentTime) {
    return <Redirect to="/" />;
  }

  if (localReload || !dbUser || !user) {
    window.location.reload();
  }
  dbUser.isDoctor = dbUser.roles.find((role) => role === "doctor");
  dbUser.isAdmin = dbUser.roles.find((role) => role === "admin");
  dbUser.levelTwo = dbUser.roles.find((role) => role === "levelTwo");
  return (
    <Route
      key={path}
      path={path}
      exact={exact}
      render={(props) =>
        loggedIn && !dbUser.levelTwo ? (
          <DefaultLayout>
            {user.emailVerified ||
            dbUser.emailVerified ||
            dbUser.admin ||
            dbUser.testUser ? (
              <TruthyComponent currentUser={dbUser} {...rest} />
                ) : (
              <VerifyEmailComponent currentUser={dbUser} />
                )}
          </DefaultLayout>
        ) : (
          <FalsyComponent />
        )
      }
    />
  );
};

const mapStateToProps = (state) => {
  const { loggedIn, dbUser, reload, user } = state.authUsers;
  return { loggedIn, dbUser, reload, user };
};

const mapDispatchToProps = (dispatch) => {
  return {
    bindReload: (content) => dispatch(SetReload(content)),
  };
};

const AuthSwitch = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthSwitchWrapper);

// const AuthSwitch = connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(AuthSwitchWrapper);

const AuthRoute = ({ component, ...rest }) => (
  <AuthSwitch
    {...rest}
    truthyComponent={component}
    falsyComponent={NotFoundComponent}
  />
);

export default AuthRoute;
